import styled from 'styled-components';

const ButtonBase = styled.button`
    display: flex;
    align-items: center;
`;

export default ButtonBase;